import React from "react";
import { startOfWeek, endOfWeek, eachDayOfInterval, format } from "date-fns";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { LineChart, cheerfulFiestaPaletteDark } from "@mui/x-charts";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import ResponsiveCharts from "../ChartsLayout/ResponsiveCharts.jsx";
import CustomGridItem from "../ChartsLayout/CustomGridItem.jsx";
import {
  HiddenTypography,
  EmptyLineChart,
} from "../ChartsLayout/EmptyCharts.jsx";

export default function WeightInsights({
  weightData,
  selectedWeek,
  weightChartInsights,
}) {
  const weekStart = startOfWeek(selectedWeek, { weekStartsOn: 1 });
  const weekEnds = endOfWeek(selectedWeek, { weekStartsOn: 1 });
  const { t } = useTranslation("statistics");

  const weekDays = eachDayOfInterval({ start: weekStart, end: weekEnds });

  const getWeightDataForADate = (date) => {
    const dateFormatted = format(date, "yyyy-MM-dd");
    const dayWeightData = weightData.find(
      (data) => data.date === dateFormatted
    );
    return dayWeightData ? dayWeightData.kgs : 0;
  };
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <ResponsiveCharts>
        {({ chartWidth }) => (
          <CustomGridItem>
            <div ref={weightChartInsights}>
              <Typography
                sx={{
                  margin: {
                    xs: "20px 0",
                    sm: "20px 0",
                    md: "0 0 20px 0",
                    lg: "20px 0 0 20px",
                    xl: "20px",
                  },
                  textAlign: "center",
                }}
                variant="h6"
              >
                {t("charts.weight.dailyWeightTitle")}
              </Typography>
              {weekDays.some((day) => getWeightDataForADate(day)) ? (
                <>
                  <HiddenTypography />

                  <LineChart
                    colors={cheerfulFiestaPaletteDark}
                    xAxis={[
                      {
                        scaleType: "band",
                        data: weekDays.map((day) => format(day, "EEE")),
                      },
                    ]}
                    series={[
                      {
                        data: weekDays.map((day) => getWeightDataForADate(day)),
                        area: true,
                        label: t("series.weightOfDay"),
                      },
                    ]}
                    width={chartWidth}
                    height={300}
                  />
                </>
              ) : (
                <EmptyLineChart weekDays={weekDays} chartWidth={chartWidth} />
              )}
            </div>
          </CustomGridItem>
        )}
      </ResponsiveCharts>
    </LocalizationProvider>
  );
}
